import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from "../../../ui/Button";
import {FormattedMessage} from "react-intl";

export class Certificate extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
    };

    render() {
        return (
            <div>
                <Button link to='/certificate' emphasis='primary' standalone>
                    <FormattedMessage id='frontend.certificate.text.open_certificate' />
                </Button>
            </div>
        );
    }
}

export default connect(() => ({
}))(Certificate);
